import { Button, Card, PageHeader } from "@/components/primitives";
import { useAihrAuth } from "@/lib/auth/useAihrAuth";

export function ProfilePage() {
  const auth = useAihrAuth();

  return (
    <div className="page">
      <PageHeader
        eyebrow="Profile"
        title={auth.user?.name ?? auth.user?.email ?? "Cosmos user"}
        subtitle="Auth0 profile and Cosmos access context."
      />
      <Card>
        {auth.user?.picture && <img className="avatar" src={auth.user.picture} alt="" />}
        <pre>{JSON.stringify(auth.user, null, 2)}</pre>
        <Button onClick={() => auth.logout()}>Sign out</Button>
      </Card>
    </div>
  );
}
